import React from "react";

function DriverPerformanceHistoricMarker({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="19"
      fill="none"
      viewBox="0 0 22 19"
    >
      <path
        fill={color}
        d="M18.88 16.47c.44-.7.7-1.51.7-2.39 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L18.5 17l.38-.53zm-3.8.11a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm-.36-8.5c-.74.02-1.45.18-2.1.45l-.55-.83-3.8 6.18-3.01-3.52-3.63 5.81L0 15l5-8 3 3.5L12 4l2.72 4.08zm2.59.5c-.64-.28-1.33-.45-2.05-.49L20.38 0 22 1.18l-4.69 7.4z"
      ></path>
    </svg>
  );
}

export default React.memo(DriverPerformanceHistoricMarker);
